import React from "react";
export default (
  <style>{`

/* loader */

#pageloader-overlay {
    opacity: 0;
    top: 0px;
    left: 0px;
    position: fixed;
    background-color: rgba(12, 71, 103, 0.28);
    height: 100%;
    width: 100%;
    z-index: 9998;
    -webkit-transition: opacity 0.2s linear;
    -moz-transition: opacity 0.2s linear;
    transition: opacity 0.2s linear;
}

    #pageloader-overlay.visible {
        opacity: 1;
    }

    #pageloader-overlay.has-status {
        background-color: rgba(16, 42, 67, 0.42);
        backdrop-filter: blur(4px);
        -webkit-backdrop-filter: blur(4px);
    }

    #pageloader-overlay.hidden {
        opacity: 0;
        height: 0px;
        width: 0px;
        z-index: -10000;
    }

    #pageloader-overlay .loader-wrapper-outer {
        background-color: transparent;
        z-index: 9999;
        margin: auto;
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: table;
        text-align: center;
        vertical-align: middle;
    }

    #pageloader-overlay .loader-wrapper-inner {
        display: table-cell;
        vertical-align: middle;
        padding: 24px;
    }

    #pageloader-overlay .loader {
        margin: auto;
        font-size: 10px;
        position: relative;
        text-indent: -9999em;
        border-top: 4px solid rgba(12, 71, 103, 0.16);
        border-right: 4px solid rgba(12, 71, 103, 0.16);
        border-bottom: 4px solid rgba(12, 71, 103, 0.16);
        border-left: 4px solid #0C4767;
        -webkit-transform: translateZ(0);
        -ms-transform: translateZ(0);
        transform: translateZ(0);
        -webkit-animation: pageloader 0.9s infinite linear;
        animation: pageloader 0.9s infinite linear;
    }

        #pageloader-overlay .loader, #pageloader-overlay .loader:after {
            border-radius: 50%;
            width: 44px;
            height: 44px;
        }

    #pageloader-overlay .loader-status {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        gap: 14px;
        max-width: 380px;
        width: 100%;
        margin: 0 auto;
        padding: 32px 28px 28px;
        background: #ffffff;
        border-radius: 16px;
        box-shadow: 0 18px 48px rgba(12, 71, 103, 0.18);
        border: 1px solid #e6edf2;
    }

    #pageloader-overlay .loader-status__spinner {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 3.5px solid #e6edf2;
        border-top-color: #0C4767;
        border-right-color: #45C48A;
        animation: pageloader 0.85s infinite linear;
    }

    #pageloader-overlay .loader-status__title {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.4;
        color: #0C4767;
        letter-spacing: -0.01em;
    }

    #pageloader-overlay .loader-status__hint {
        margin: 0;
        font-size: 13px;
        font-weight: 500;
        line-height: 1.4;
        color: #627d98;
    }

@-webkit-keyframes pageloader {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@keyframes pageloader {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

`}</style>
);
